import { create } from "zustand";
import type { LocalProject, ProjectSaveStatus } from "./types";

type ProjectState = {
  initialized: boolean;
  activeLocalProjectId: string | null;
  localRevision: number;
  saveStatus: ProjectSaveStatus;
  saveError: string | null;
  setInitialized(value: boolean): void;
  activate(project: LocalProject): void;
  setRevision(revision: number): void;
  setSaveStatus(status: ProjectSaveStatus, error?: string | null): void;
  clear(): void;
};

export const useProjectStore = create<ProjectState>((set) => ({
  initialized: false,
  activeLocalProjectId: null,
  localRevision: 0,
  saveStatus: "initializing",
  saveError: null,
  setInitialized: (initialized) => set({ initialized }),
  activate: (project) =>
    set({
      activeLocalProjectId: project.id,
      localRevision: project.revision,
      initialized: true,
      saveStatus: project.syncState === "synced" ? "saved-cloud" : "saved-local",
      saveError: null,
    }),
  setRevision: (localRevision) => set({ localRevision }),
  setSaveStatus: (saveStatus, saveError = null) => set({ saveStatus, saveError }),
  clear: () =>
    set({
      activeLocalProjectId: null,
      localRevision: 0,
      saveStatus: "initializing",
      saveError: null,
    }),
}));

